import type { IdleDecision, SessionPolicy } from './types';

export interface EnforceInput {
    lastActivityMs: number;
    policy: SessionPolicy;
    now: number;
}

export function enforceIdle({ lastActivityMs, policy, now }: EnforceInput): IdleDecision {
    const idleMs = now - lastActivityMs;
    const idleLimitMs = policy.idleMinutes * 60 * 1000;
    const warnAtMs = (policy.idleMinutes - policy.warningMinutes) * 60 * 1000;

    if (idleMs >= idleLimitMs) {
        return { kind: 'expired' };
    }
    if (idleMs >= warnAtMs) {
        return {
            kind: 'warn',
            remainingSeconds: Math.ceil((idleLimitMs - idleMs) / 1000),
        };
    }
    return { kind: 'ok' };
}
